import './percents.component.scss'

import $ from 'jquery'

import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/effect-fade'
import Swiper, { Autoplay, EffectFade } from 'swiper'
Swiper.use([Autoplay, EffectFade])

$(document).ready(function () {
  new Swiper('.percents__facts .swiper-container', {
    slidesPerView: 1,
    loop: true,

    effect: 'fade',
    fadeEffect: {
      crossFade: false
    },
    autoplay: {
      duration: 2500
    },
    followFinger: false,
    allowTouchMove: false,
  });
});